/*******************************************************************************
 
    Project: SVA
    Author: Prima-Line.de
    Date: 06.2015 
 
********************************************************************************

    1. Article Slideshow
    2. Link Blocks
    3. Footer logos
    4. Toggler
    5. Back
    6. Scroll to top
    7. Lightbox effect
    8. Block slideshow
    9. Accordions
    10. Referenzen
    11. News slider
 
*******************************************************************************/

jQuery( document ).ready(function($) {

/* 1. Article Slideshow
------------------------------------------------------------------------------*/

    $('.art-slide__slick').slick({
        arrows: false,
        dots: true,
        lazyLoad: 'ondemand',
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 900,
        appendDots: $('.art-slide .dots-wrap')
    });

/* 2. Link Blocks
------------------------------------------------------------------------------*/

    enquire.register("screen and (min-width: 767px)", {
        match : function() {
            $('.link-block__lnk').matchHeight();
        },      
        unmatch : function() {
            $('.link-block__lnk').matchHeight('remove');
        }
    });

/* 3. Footer logos
------------------------------------------------------------------------------*/

    $('.logos').slick({
        arrows: false,
        dots: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

/* 4. Toggler
------------------------------------------------------------------------------*/

    $(".toggle-hidden-content").click(function () {        
        var txt = $(this).parent().prev().is(':visible') ? LG_show : LG_hide;
        $(this).parent().prev().slideToggle("slow");
        $(this).text(txt);
        return false;     
    }); 

/* 5. Back
------------------------------------------------------------------------------*/

    $('.back-to-previous').on('click', function(e){
        e.preventDefault();
        window.history.back();
    });

/* 6. Scroll to top
------------------------------------------------------------------------------*/

    $(document).on( 'scroll', function(){
        if ($(window).scrollTop() > 200) {
            $('.scroll-to-top').addClass('show');
        } else {
            $('.scroll-to-top').removeClass('show');
        }
    });

    $('.scroll-to-top').on('click', function(event) {
        event.preventDefault();
        var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
        var element = $('body');
        var offset = element.offset();
        var offsetTop = offset.top;
        $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
    });

/* 7. Lightbox effect
------------------------------------------------------------------------------*/

    $(".fancybox").fancybox({
        openEffect  : 'fade',
        closeEffect : 'fade',
        helpers : {
            media : {}
        }
    });

    // Initialize the Lightbox automatically for any links to images with extensions .jpg, .jpeg, .png or .gif
    $("a[href$='.jpg'], a[href$='.png'], a[href$='.jpeg'], a[href$='.gif']").fancybox();


/* 8. Block slideshow
------------------------------------------------------------------------------*/

    $('.block-slideshow__wrap').slick({
        adaptiveHeight: true,
        infinite: true
    });

/* 9. Accordions
------------------------------------------------------------------------------*/

    if (window.location.hash) {
        var anchor = window.location.hash.replace("#", "");
        var headerEl = $('#header-'+anchor);
        $(".collapse").collapse('hide');
        $("#collapse-" + anchor).collapse('show');
        $("#collapse-" + anchor).prev('.accordion__title-wrap').addClass('active');
        $('html, body').stop().delay(500).animate({
            'scrollTop': headerEl.offset().top
        }, 1000);
    }

    $(window).on('hashchange', function() {
        var anchor = window.location.hash.replace("#", "");
        var headerEl = $('#header-'+anchor);
        $(".collapse").collapse('hide');
        $("#collapse-" + anchor).collapse('show');
        $("#collapse-" + anchor).prev('.accordion__title-wrap').addClass('active');
        $('html, body').stop().animate({
            'scrollTop': headerEl.offset().top
        }, 1000);
    });
    
    $('.wrap .ubermenu .ubermenu-submenu-type-stack>.ubermenu-item-normal>.ubermenu-target').on('click', function(){
        $('.ubermenu').ubermenu('closeAllSubmenus');
    });

    $('.accordion__title-wrap').on('click', function(){
        $(this).parent().parent().find('.collapse').collapse('hide');
        $("#collapse-" + $(this).attr('id')).collapse('show');
        window.location.hash = $(this).attr('id').replace('header-', '');
    });

    $('.collapse').on('shown.bs.collapse', function () {
        var $target = $(this);
        var $target_header = $(this).prev();
        $('html, body').stop().animate({
            'scrollTop': $target_header.offset().top
        }, 1000, function () {
            
        });
    });

    $('.accordion__group')
        .on('show.bs.collapse', function(e) {
            $(e.target).prev('.accordion__title-wrap').addClass('active');
        })
        .on('hide.bs.collapse', function(e) {
            $(e.target).prev('.accordion__title-wrap').removeClass('active');
        });



/* 10. Referenzen
------------------------------------------------------------------------------*/

    enquire.register("screen and (min-width: 767px)", {
        match : function() {
            $('.ref__item').matchHeight();
            $('.ref__img-wrap, .ref__title-wrap').matchHeight();
        },      
        unmatch : function() {
            $('.ref__item').matchHeight('remove');
            $('.ref__img-wrap, .ref__title-wrap').matchHeight('remove');
        }
    });

/* 11. News slider
------------------------------------------------------------------------------*/

    $('.news-module__wrap').slick({
        adaptiveHeight: true,
        dots: true,
        arrows: false
    });

/* 12. Browser resize events
------------------------------------------------------------------------------*/

$(window).on("debouncedresize", function( event ) {
    $.fn.matchHeight._update();
});


});